import React, { Component } from 'react'
import { connect } from 'react-redux'
import withFilterOptions from '../hocs/withFilterOptions'
import { getValueAttribute, getLabelAttribute, getApi } from '../utils/apis'
import { Select } from 'antd'
import Format from '../containers/Format'
import FormItem from './FormItem'
import { getAttribute } from '../utils/models'

const Option = Select.Option

class Api extends Component {

    constructor(props) {
        super(props)

        this.state = {
            items: []
        }
    }

    componentDidMount() {
        this.mounted = true

        const api = getApi(this.props.model, this.props.attribute)

        this.setState({ items: this.props.apis[api] })
    }

    componentDidUpdate(prevProps) {
        const api = getApi(this.props.model, this.props.attribute)

        if (this.props.apis[api].length !== prevProps.apis[api].length) {
            this.setState({ items: this.props.apis[api] })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const api = getApi(this.props.model, this.props.attribute)
        const valueAttribute = getValueAttribute(api)
        const labelAttribute = getLabelAttribute(api)
        const attribute = getAttribute(this.props.model, this.props.attribute)

        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
                    <Select
                        disabled={this.props.disabled}
                        style={{ width: '100%' }}
                        allowClear={!attribute.required}
                        onChange={this.props.handleChange}
                        filterOption={this.props.filterOption}
                        showSearch
                        notFoundContent={'Not found'}
                    >
                        {this.state.items.map((item, index) => (
                            <Option key={index} value={String(item[valueAttribute])}>
                                <Format
                                    model={this.props.model}
                                    attribute={this.props.attribute}
                                    value={item[labelAttribute]}
                                />
                            </Option>
                        ))}
                    </Select>
                )}
            </FormItem>
        )
    }

}

const mapStateToProps = state => ({
    apis: state.apis
})

export default (
    withFilterOptions(
        connect(mapStateToProps)(Api)
    )
)


// WEBPACK FOOTER //
// ./src/inputs/Api.js